import React from 'react';
import ToolbarBase from '@material-ui/core/Toolbar';

const Toolbar = (props) => <ToolbarBase {...props} />;

export default Toolbar;
